/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any */

import { Earnings } from 'types/shared';

export const getEarningsObj = (e: any): Earnings => ({
  activityFactor: e.activity_factor,
  companyName: e.company_name,
  impliedMove: e.implied_move,
  ...e,
});
